import type { CommandData } from '../types'

export function close() {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'close',
  }
  window.postMessage(message)
}
